/* eslint-disable import/no-anonymous-default-export */
import Repository from "./repository";

const RESTAURANT_STAT = "/stats/get-stats";
const ORDER_ANALYSIS = "/stats/orders-analysis";
const REVENUE_EARNED = "/stats/revenue-earned";
const SELLERS_CHART = "stats/sellers";
const VISIT_CARD = "/stats/visits";
const PEAK_HOUR = "/stats/peak-hours";
const TOTAL_CUSTOMER = "/stats/total-customers";
const PAYMENT_METHOD = "/stats/payment-methods";
const TOP_MERCHANT = "/stats/top-merchants";

export default {
  getRestaurantStats(payload) {
    const { id, type, dateRange } = payload;
    const queryParams =
      type === "range"
        ? `restaurantID=${id}&type=${type}&startDate=${dateRange?.startDate}&endDate=${dateRange?.endDate}`
        : `restaurantID=${id}&type=${type}`;
    return Repository.get(`${RESTAURANT_STAT}?${queryParams}`);
  },
  getOrderAnalysis(payload) {
    const { id, type, dateRange } = payload;

    const queryParams =
      type === "range"
        ? `restaurantID=${id}&type=${type}&startDate=${dateRange?.startDate}&endDate=${dateRange?.endDate}`
        : `restaurantID=${id}&type=${type}`;
    return Repository.get(`${ORDER_ANALYSIS}?${queryParams}`);
  },
  getRevenueEarned(payload) {
    const { id, type, dateRange } = payload;
    const queryParams =
      type === "range"
        ? `restaurantID=${id}&type=${type}&startDate=${dateRange?.startDate}&endDate=${dateRange?.endDate}`
        : `restaurantID=${id}&type=${type}`;
    return Repository.get(`${REVENUE_EARNED}?${queryParams}`);
  },
  getSellersCharts(payload) {
    const { id, type, dateRange } = payload;
    const queryParams =
      type === "range"
        ? `restaurantID=${id}&type=${type}&startDate=${dateRange?.startDate}&endDate=${dateRange?.endDate}`
        : `restaurantID=${id}&type=${type}`;
    return Repository.get(`${SELLERS_CHART}?${queryParams}`);
  },
  getVisits(payload) {
    const { id, type, dateRange } = payload;
    const queryParams =
      type === "range"
        ? `restaurantID=${id}&type=${type}&startDate=${dateRange?.startDate}&endDate=${dateRange?.endDate}`
        : `restaurantID=${id}&type=${type}`;
    return Repository.get(`${VISIT_CARD}?${queryParams}`);
  },
  getPeakHours(payload) {
    const { id, type, dateRange } = payload;
    const queryParams =
      type === "range"
        ? `restaurantID=${id}&type=${type}&startDate=${dateRange?.startDate}&endDate=${dateRange?.endDate}`
        : `restaurantID=${id}&type=${type}`;
    return Repository.get(`${PEAK_HOUR}?${queryParams}`);
  },
  getTopMerchants(payload) {
    const { id, type, dateRange } = payload;
    const queryParams =
      type === "range"
        ? `restaurantID=${id}&type=${type}&startDate=${dateRange?.startDate}&endDate=${dateRange?.endDate}`
        : `restaurantID=${id}&type=${type}`;
    return Repository.get(`${TOP_MERCHANT}?${queryParams}`);
  },
  getPaymentMethod(payload) {
    const { id, type, dateRange } = payload;
    const queryParams =
      type === "range"
        ? `restaurantID=${id}&type=${type}&startDate=${dateRange?.startDate}&endDate=${dateRange?.endDate}`
        : `restaurantID=${id}&type=${type}`;
    return Repository.get(`${PAYMENT_METHOD}?${queryParams}`);
  },
  getTotalCustomer(payload) {
    const { id, type, dateRange } = payload;
    const queryParams =
      type === "range"
        ? `restaurantID=${id}&type=${type}&startDate=${dateRange?.startDate}&endDate=${dateRange?.endDate}`
        : `restaurantID=${id}&type=${type}`;
    return Repository.get(`${TOTAL_CUSTOMER}?${queryParams}`);
  },
};
